require('./helpers/bundle-manifest').register(JSON.parse("{\"5ZPII\":\"index.1307e1d5.js\",\"a9Ruw\":\"logo.1af7a8e1.png\",\"efCe2\":\"index.6f414b11.css\"}"));